import './Construccion.css';
import React from "react";
import { Link } from "react-router-dom";
import Construccion1 from '../../assets/Productos/Construccion/Construccion1.png';
import Construccion2 from '../../assets/Productos/Construccion/Construccion2.png';
import Construccion3 from '../../assets/Productos/Construccion/Construccion3.png';
import Construccion4 from '../../assets/Productos/Construccion/Construccion4.png';
import Construccion5 from '../../assets/Productos/Construccion/Construccion5.png';
import Construccion6 from '../../assets/Productos/Construccion/Construccion6.png';
import Construccion7 from '../../assets/Productos/Construccion/Construccion7.png';
import Construccion8 from '../../assets/Productos/Construccion/Construccion8.png';
import Construccion9 from '../../assets/Productos/Construccion/Construccion9.png';
import Construccion10 from '../../assets/Productos/Construccion/Construccion10.png';
import Construccion11 from '../../assets/Productos/Construccion/Construccion11.png';
import Construccion12 from '../../assets/Productos/Construccion/Construccion12.png';
import Construccion13 from '../../assets/Productos/Construccion/Construccion13.png';
import Construccion14 from '../../assets/Productos/Construccion/Construccion14.png';
import Construccion15 from '../../assets/Productos/Construccion/Construccion15.png';
import Construccion16 from '../../assets/Productos/Construccion/Construccion16.png';
import Construccion17 from '../../assets/Productos/Construccion/Construccion17.png';
import Construccion18 from '../../assets/Productos/Construccion/Construccion18.png';
import Construccion19 from '../../assets/Productos/Construccion/Construccion19.png';
// import Construccion20 from '../../assets/Productos/Construccion/Construccion20.png';
import Construccion21 from '../../assets/Productos/Construccion/Construccion21.png';
import Construccion22 from '../../assets/Productos/Construccion/Construccion22.png';

const images = [
    // { src: Construccion1, text: "MF930 Mirror Silicone Sealant", id: 1 },
    { src: Construccion2, text: "MF910H Sellador de butilo 2da barrera", id: 2 },
    { src: Construccion3, text: "MF910G Sellador de butilo 1ra barrera", id: 3 },
    { src: Construccion4, text: "MF910 Sellador de butilo 1ra barrera", id: 4 },
    // { src: Construccion5, text: "MF899F Fireproofing Silicone Structural Sealant", id: 5 },
    // { src: Construccion6, text: "MF899T Transparent Silicone Structural Sealant", id: 6 },
    // { src: Construccion7, text: "MF899-25 Silicone Structural Sealant", id: 7 },
    { src: Construccion8, text: "MF899 Sellador de silicona estructural transparente", id: 8 },
    // { src: Construccion9, text: "MF898 Silicone Weatherproofing Sealant", id: 9 },
    // { src: Construccion10, text: "MF897 Silicone Anti-Mildew Sealant", id: 10 },
    { src: Construccion11, text: "MF890 Sellador de silicona para construcción", id: 11 },
    // { src: Construccion12, text: "MF889F-25 single-component silicone weathering sealant", id: 12 },
    // { src: Construccion13, text: "MF889A Silicone Stone Weatherproofing Sealant", id: 13 },
    // { src: Construccion14, text: "MF889-25 Silicone Weatherproofing Sealant", id: 14 },
    { src: Construccion15, text: "MF889 Sellador de silicona climático", id: 15 },
    // { src: Construccion16, text: "MF883 Silicone Sealant for Insulating Glass", id: 16 },
    // { src: Construccion17, text: "MF840 Two-component Polysulfide Sealant Special for Manufacture of Insulating Glass", id: 17 },
    // { src: Construccion18, text: "MF882 Two-component Silicone Sealant for Insulating Glass", id: 18 },
    // { src: Construccion19, text: "MF881-25G Two Component Silicone Structural Sealant", id: 19 },
    // { src: Construccion20, text: "MF883 Silicone Sealant for Insulating Glass", id: 20 },
    // { src: Construccion21, text: "MF881-25 Two-component Silicone Structural Sealant for Insulating Glass", id: 21 },
    // { src: Construccion22, text: "MF881 Two-component Silicone Structural Sealant for Insulating Glass", id: 22 },
];

function Construccion() {
    return (
        <div className="arquitectura-container">
            <div className="arquitectura-grid">
                {images.map((item, index) => (
                    <div key={index} className="arquitectura-item">
                        <Link to={`/productos/${item.id}`}>
                            <img src={item.src} alt={item.text} />
                        </Link>
                        <p>{item.text}</p> {/* Nombre del producto sin enlace */}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Construccion;
